import { render, staticRenderFns } from "./szgs.vue?vue&type=template&id=a11349fc&scoped=true&"
import script from "./szgs.vue?vue&type=script&lang=js&"
export * from "./szgs.vue?vue&type=script&lang=js&"
import style0 from "./szgs.vue?vue&type=style&index=0&id=a11349fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11349fc",
  null
  
)

export default component.exports